import { IKnmErknmState } from '../interfaces/IKnmErknmState';
import { KnmErknmActionsEnum } from '../enums/KnmErknmActionsEnum';
import { KnmErknmAction } from '../types/KnmErknmAction';

const initialState: IKnmErknmState = {
  initialFormValues: {
    knoOrganizationErknm: undefined,
    organizations: [],
  },
  isPrescriptionCheckByOldRules: undefined,
  isPassportByCheckPrescriptionFailed: undefined,
  wasFirstInit: false,
};

export function knmErknmReducer(state: IKnmErknmState = initialState, action: KnmErknmAction): IKnmErknmState {
  switch (action.type) {
    case KnmErknmActionsEnum.KNM_SET_INITIAL_FORM_VALUES: {
      const { initialFormValues } = action.payload;

      return {
        ...state,
        initialFormValues: {
          ...state.initialFormValues,
          ...initialFormValues,
        },
      };
    }
    case KnmErknmActionsEnum.KNM_ERKNM_SET_PRESCRIPTION_OLD_RULES: {
      return { ...state, isPrescriptionCheckByOldRules: action.payload.value };
    }
    case KnmErknmActionsEnum.KNM_ERKNM_SET_PRESCRIPTION_FAILED: {
      return { ...state, isPassportByCheckPrescriptionFailed: action.payload.value };
    }
    case KnmErknmActionsEnum.KNM_ERKNM_RESET_INITIAL_FORM_VALUES: {
      return {
        ...state,
        initialFormValues: initialState.initialFormValues,
        isPrescriptionCheckByOldRules: undefined,
        isPassportByCheckPrescriptionFailed: undefined,
      };
    }
    case KnmErknmActionsEnum.KNM_ERKNM_SET_FIELDS_FOR_APPROVING: {
      const { fieldsForApproving } = action.payload;

      return {
        ...state,
        fieldsForApproving,
      };
    }
    case KnmErknmActionsEnum.KNM_ERKNM_SET_IS_SHOW_MESSAGE_BY_STATUS: {
      const { isShowMessageByStatus } = action.payload;

      return {
        ...state,
        isShowMessageByStatus,
      };
    }
    case KnmErknmActionsEnum.KNM_ERKNM_SET_WAS_FIRST_INIT: {
      const { wasFirstInit } = action.payload;

      return {
        ...state,
        wasFirstInit,
      };
    }
    default:
      return state;
  }
}
